import useScreenSize from '../../hooks/useScreenSize'
import './typography.scss'

//textType = welcome , description , login-button , button , forgot, error, sidebar;
//textWeight = 400, 500, 600, 700;
//textColor = black , white , red;

const Typography = ({
  textType = 'normal',
  textColor = 'black',
  textWeight = '400',
  textAlign,
  justify = 'center',
  width = '100',
  transform = 'unset',
  children,
  ...rest
}) => {
  const screenSize = useScreenSize()
  return (
    <div
      className={`typography flex align-center justify-${justify} text-${textType} ${screenSize} text-${textColor} text-${textWeight} text-${textAlign} text-${width} text-${transform} fontfamily`}
      {...rest}
    >
      {children}
    </div>
  )
}

export default Typography
